module.exports = __webpack_public_path__ + "static/media/116.16ca8dbc.wav";